// Module
var code = "<p>We mail <strong>Interest Bills</strong> 21 days before your payment due date if you decide to pay your interest while in deferment, forbearance, grace, or in-school status.</p> ";
// Exports
export default code;